<template>
  <div class="login-container">
    <img src="../../assets/img/fullScreen.png" class="fullScreen" @click="toFull" alt="">
    <img src="../../assets/img/cebsblogo_white.png" class="left-logo" alt="">
    <div class="login-box">
      <div class="login-txt">区域决选考生登录</div>
      <el-form
        ref="loginFormRef"
        class="login_form"
        :rules="loginFormRules"
        :model="loginForm"
      >
        <el-form-item prop="phone">
          <el-input class="input"
            v-model="loginForm.phone"
            prefix-icon="iconfont icon-user"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input class="input"
            v-model="loginForm.password"
            prefix-icon="iconfont icon-key"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button class="login-btn" type="primary" @click="mainLogin"  @keyup.enter="mainLogin(e)"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 确认弹窗 -->
    <customConfirm v-if="confirmVisible"
      :msg="msg"
      :enMsg="enMsg"
      :confirm="okText"
      :enConfirm="okEnText"
      :cancel="cancelText"
      :enCancel="cancelEnText"
      :isPhone="isPhone"
      @cancel="cancelFn()"
      @confirm="confirmFn()"></customConfirm>
  </div>
</template>

<script>
// 汉英复赛平板答题，注意使用复赛网站请求域名！！！！！this.base
import env from '@/http/env'
export default {
  data () {
    return {
      season: '2024~2025',
      raceSchedule: '2', // 复赛平板答题
      activityType: '1',
      loginForm: {
        phone: '',
        password: ''
      },
      loginFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      userList: [],
      selectUserDialogViaible: false,
      sending: false,
      sendDisabled: false,
      loading: false,
      timer: 0,
      base: env.baseWebIP,
      signUpTime: [], // 报名时间
      examinationTime: [], // 考试时间
      publishTime: '',
      confirmVisible: false,
      okText: '确认',
      okEnText: 'Confirm',
      cancelText: '',
      cancelEnText: '',
      msg: '',
      enMsg: '',
      isPhone: false
    }
  },
  mounted () {
    // 绑定监听事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed () {
    // 销毁事件
    window.removeEventListener('keydown', this.keyDown, false)
  },
  created () {
    this.isPhone = window.screen.width < 500
    this.getSeason()
  },
  methods: {
    // 点击回车键登录
    keyDown (e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        this.mainLogin() // 定义的登录方法
      }
    },
    resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
    },
    // 登录
    mainLogin () {
      localStorage.removeItem('Authorization')
      localStorage.clear()
      const formData = new FormData()
      formData.append('phone', this.loginForm.phone)
      formData.append('password', this.loginForm.password)
      console.log(formData)
      this.$refs.loginFormRef.validate(valid => {
        if (!valid) return
        this.isLogonState = true
        this.$http.post(this.base + 'common/loginWebByPhone', formData).then(res => {
          this.isLogonState = false
          if (res.code === 200) {
            // 获取个人信息存储
            // this.getUserInfo()
            this.checkBasicInfo()
            localStorage.setItem('isStu', '1')
          }
        }).catch(() => {
          this.isLogonState = false
        })
      })
    },
    getSeason () {
      this.$http.get('season/seasonActivityIng/' + this.activityType).then(res => {
        if (res.code === 200) {
          this.season = res.data.season
        }
      })
    },
    getUserInfo () {
      this.$http.post(this.base + 'user/getBasicsUserInfo').then(res => {
        if (res.code === 200) {
          localStorage.setItem('SYS_USER', JSON.stringify(res.data.sysUser))
          localStorage.setItem('SYS_USER_SCHOOL', JSON.stringify(res.data.sysUserInfo))

          this.$router.push('/padSemiBefore')
        }
      })
    },
    toFull () {
      this.$xcUtils.toFull()
    },
    // 获取比赛时间
    getSeasonRaceScheduleTime () {
      this.$http.get(`${this.base}raceSchedule/getSeasonRaceScheduleTime?id=${this.raceSchedule}&season=${this.season}`).then(res => {
        if (res.code === 200) {
          this.timeInfo = res.data
          this.signUpTime[0] = new Date(res.data.signUpStartTime).getTime()
          this.signUpTime[1] = new Date(res.data.signUpEndTime).getTime()
          this.examinationTime[0] = new Date(res.data.examinationStartTime).getTime()
          this.examinationTime[1] = new Date(res.data.examinationEndTime).getTime()
          this.publishTime = new Date(res.data.publishTime).getTime()
          this.handleToAnswer()
        }
      })
    },
    checkBasicInfo () {
      this.$http.get(`${this.base}user/checkBasicsUserInfo`).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.getSeasonRaceScheduleTime()
        } else if (res.code === 2014) {
          this.showConfirm('请到小程序完善个人信息')
        }
      })
    },
    handleToAnswer () {
      const now = new Date().getTime()
      if (this.examinationTime[0] > now) {
        console.log(1)
        this.showConfirm('未到考试开始时间')
      } else if (this.examinationTime[1] < now) {
        console.log(2)
        this.showConfirm('考试已结束')
      } else {
        // 查询是否作答
        this.checkAnswerd()
      }
    },
    checkAnswerd () {
      this.$http.get(`${this.base}formMatch/queryUserHasAnswered?activityType=${this.activityType}&raceSchedule=${this.raceSchedule}&season=${this.season}`).then(res => {
        if (res.code === 200) {
          if (res.data.isEnrollment) {
            if (res.data.isAnswer) {
              // this.showConfirm('您已完成复赛答题')
              this.$router.push('/padSemiResult')
            } else {
              this.getTbEnrollmentIng()
            }
          } else {
            this.showConfirm('未查询到您的报名信息，请您先进行‘区域决选报名’')
          }
        }
      })
    },
    getTbEnrollmentIng () {
      this.$http.get(`${this.base}enrollment/getTbEnrollmentIng?raceSchedule=${this.raceSchedule}&activityType=${this.activityType}&season=${this.season}`).then(res => {
        if (res.code === 200) {
          if (!res.data.isEnrollment) {
            this.showConfirm('未查询到您的报名信息，请您先进行‘区域决选报名’')
          } else if (!res.data.isChooseSit) {
            // isChooseSit     true:已选考位 false:未选考位
            this.showConfirm('您已报名线下区域决选，请点击查询考场选择比赛场次')
          } else {
            const sTime = new Date(res.data.examinationRoom.roomStartTime).getTime()
            const eTime = new Date(res.data.examinationRoom.roomEndTime).getTime()
            const now = new Date().getTime()
            console.log(now, sTime, eTime)
            if (now < sTime) {
              // 未开始
              this.showConfirm('答题暂未开始')
            } else if (now > eTime) {
              // 已结束
              this.showConfirm('答题已结束')
            } else {
              this.getUserInfo()
            }
          }
        }
      })
    },
    showConfirm (msg, enMsg) {
      this.msg = msg
      this.enMsg = enMsg || ' '
      this.confirmVisible = true
    },
    confirmFn () {
      this.confirmVisible = false
    },
    cancelFn () {
      this.confirmVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  // background-color: #2b5b6b;
  background-image: url(https://cdn.spbcn.org/chineseWord/erp/product/images/bg.png);
  background-size: cover;
  background-position: center;
  height: 100%;
  .left-logo{
    width: 234px;
    height: auto;
    margin-left: 50px;
    margin-top: 40px;
  }
  .login-btn{
    width: 180px;
    border-radius: 40px;
    background-color: #cbae72;
    border-color: #cbae72;
    margin-top: 20px;
    margin-bottom: 20px;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.35);
    }
  }
  .login-txt{
    font-size: 24px;
    color: #333;
    margin-left: 30px;
    margin-top: 40px;
    padding-bottom: 4px;
    border-bottom: 3px solid #cbae72;
    width: 70%;
  }
  .send-btn{
    border: none;
    &:hover, &:focus{
      color: #cbae72;
      background-color: transparent;
    }
  }
  .input ::v-deep .el-input__inner{
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #DCDFE6;
  }
  .login-box {
    width: 450px;
    height: 360px;
    background-color: #fff;
    border-radius: 12px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .avatar_box {
      height: 130px;
      width: 130px;
      border: 1px solid #eee;
      border-radius: 50%;
      padding: 10px;
      box-shadow: 0 0 10px #ddd;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;

      img {
        width: 100%;
        height: auto;
      }
    }

    .login_form {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: 0 30px;
      box-sizing: border-box;

      .btns {
        display: flex;
        justify-content: center;
      }
    }
  }
  @media screen and (max-width: 500px) {
    /* 在这里应用适合小屏幕设备的样式 */
    .login-box {
      width: 90%;
    }
    .login-txt{
      width: auto;
      margin-right: 30px;
    }
  }
}

.fullScreen{
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 30px;
  height: 30px;
}
*{
  -webkit-tap-highlight-color: transparent;
}
</style>
